import { render, staticRenderFns } from "./suplierCurrentReport.vue?vue&type=template&id=758ea8c4"
import script from "./suplierCurrentReport.vue?vue&type=script&lang=js"
export * from "./suplierCurrentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports